import React, { useContext, useState, useEffect } from 'react';
import {
  CheckoutProvider
} from '@stripe/react-stripe-js';
import {fetchPaymentConfig, fetchPaymentSession} from "../../http/userAPI";
import { Context } from "../../index";
import { loadStripe } from '@stripe/stripe-js';
import CheckoutFormSub from './CheckoutFormSub';
import PayButton from "./PayButton";

const UserPaySubscription = () => {
    const [clientSecret, setClientSecret] = useState(null);
    const [stripePromise, setStripePromise] = useState(null);
    const priceId = "price_1Qj";

    const { user } = useContext(Context);

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const { publishableKey } = await fetchPaymentConfig();

                if (publishableKey) {
                    setStripePromise(loadStripe(publishableKey,
                        {
                            betas: ['custom_checkout_beta_5'],
                        }
                        ));
                    console.log("Stripe Publishable Key:", publishableKey);
                } else {
                    console.error("Ошибка: publishableKey отсутствует!");
                }
            } catch (error) {
                console.error("Ошибка загрузки конфигурации Stripe:", error);
            }
        };

        fetchConfig();
    }, []);


    // Функция получения сессии
    const fetchSession = async () => {
        try {
            console.log('Запрос сессии на сервер...');
            const data = await fetchPaymentSession(user.user.id, user.user.email, priceId);
            console.log('Ответ', data);  // Логируем сам ответ

            if (data && data.client_secret) {
                setClientSecret(data.client_secret);
            }
        } catch (error) {
            console.error('Ошибка при получении сессии:', error);
        }
    };

    useEffect(() => {
        fetchSession();  // Вызываем функцию при монтировании компонента
    }, [user.user.id]);  // Это зависит от объекта `user`, так что компонент обновится, когда изменится `user`


    if (clientSecret) {
        return (

            <div className="container d-flex justify-content-lg-start mt-2">
                <div className="col-md-8 p-2 bg-white shadow rounded">
                    <CheckoutProvider stripe={stripePromise} options={{clientSecret}}>
                        <div className="w-100">
                            <CheckoutFormSub/>
                            <PayButton
                                billingAddress={{
                                    name: "John Morrison",
                                    address: {
                                        line1: "Mega street 10001",
                                        city: "New York City",
                                        state: "NY",
                                        postal_code: "10001",
                                        country: "US"
                                    }
                                }}
                                redirect="always"
                            />
                        </div>
                    </CheckoutProvider>
                </div>
            </div>

        );
    } else {
        return <div>Loading...</div>; // Показываем "Загрузка", пока не получим clientSecret
    }
};

export default UserPaySubscription;
